export const FETCH_COMMON_DATA = "FETCH_COMMON_DATA";
export const FETCH_COMMON_FAILED = "FETCH_COMMON_FAILED";

// -------------------------------------------------------------------

export const FETCH_ABOUTME = "FETCH_ABOUTME";
export const FETCH_EXPERIENCES = "FETCH_EXPERIENCES";
export const FETCH_BLOGS = "FETCH_BLOGS";
export const FETCH_DETAILS_FAILED = "FETCH_DETAILS_FAILED";

// -------------------------------------------------------------------
export const FETCH_FEAT_PROJ = "FETCH_FEAT_PROJ";
export const FETCH_OTHER_PROJ = "FETCH_OTHER_PROJ";
export const FETCH_DESIGN_PROJ = "FETCH_DESIGN_PROJ";
export const FETCH_PROJ_FAILED = "FETCH_PROJ_FAILED";
